import type { ZendeskLocale } from "@/locales/fr/zendesk";

import { EZendeskTicketStatus } from "@/types/backoffice/dto/zendesk/zendesk-ticket-dto.ts";

const zendeskLocale: ZendeskLocale = {
  zendesk: {
    ticketId: "Ticket ID",
    ticketStatus: "Status",
    assignee: "Assignee",
    ticketSubject: "Subject",
    createdAt: "Creation date",
    updatedAt: "Last modification date",
    status: {
      [EZendeskTicketStatus.NEW]: "New",
      [EZendeskTicketStatus.OPEN]: "Open",
      [EZendeskTicketStatus.PENDING]: "Pending",
      [EZendeskTicketStatus.HOLD]: "Hold",
      [EZendeskTicketStatus.SOLVED]: "Solved",
      [EZendeskTicketStatus.CLOSED]: "Closed",
      [EZendeskTicketStatus.UNKNOWN]: "Unknown",
    },
  },
};

export default zendeskLocale;
